import { createContext, useContext, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { DEFAULT_COUNTRY, FOOD_TYPE } from '../../constants';
import { SERVICE_MODES } from '../../pages/OrderPage/constants';

const context = createContext();

export const useInitialState = () => {
	const [isDesktop, setIsDesktop] = useState(!isMobile);
	const [sidebarShow, setSidebarShow] = useState('responsive');

	const [restaurantDetails, setRestaurantDetails] = useState();
	const [defaultItemSelector, setDefaultItemSelector] = useState({
		foodType: FOOD_TYPE.VEG_FOOD_TYPE,
		subCategory: null,
	});

	const [config, setConfig] = useState({});

	const [countryInfo, setCountryInfo] = useState(DEFAULT_COUNTRY);
	const [currentTimeline, setCurrentTimeline] = useState();

	const [alertCaller, setAlertCaller] = useState();
	const [toastAlert, setToastAlert] = useState();

	const setConfiguration = (key, value) => {
		const newConfig = { ...config };
		newConfig[key] = value;
		setConfig(newConfig);
	};

	const [activeServices, setActiveServices] = useState([]);

	return {
		isDesktop,
		setIsDesktop,
		sidebarShow,
		setSidebarShow,
		restaurantDetails,
		setRestaurantDetails,
		defaultItemSelector,
		setDefaultItemSelector,
		countryInfo,
		setCountryInfo,
		config,
		setConfiguration,
		currentTimeline,
		setCurrentTimeline,
		alertCaller,
		setAlertCaller,
		toastAlert,
		setToastAlert,
		activeServices,
		setActiveServices,
	};
};

export const useCustomContext = () => {
	return useContext(context);
};

export default context;
